import React, { useState, useEffect } from 'react';
import { Grid, Segment, Breadcrumb, Form, Button, Message } from 'semantic-ui-react';
import { Link, useHistory } from 'react-router-dom';
import _ from 'lodash';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { ProjectInnerForm } from './ProjectInnerForm';
import apiRequest from '../../../app/common/api/apiClient';

const s = (val) => (val !== undefined && val !== null ? `${val}` : '');

const ProjectsUpdate = ({ match }) => {
  const idProject = match.params.id;
  const history = useHistory();
  const [project, setProject] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    apiRequest(`/api/cases/${idProject}`)
      .then((res) => res.json())
      .then((data) => setProject(data.properties || {}))
      .catch((err) => { console.error(err); setError(err.message); });
  }, [idProject]);

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Títulu kazu nesesáriu'),
  });

  if (!project) return <Segment loading style={{ minHeight: '200px' }} />;

  const initialValues = {
    ref_kazu:                    s(project.ref_kazu),
    name:                        s(project.name),
    status:                      s(project.status),
    municipality:                s(project.municipality),
    postu:                       s(project.postu),
    suku:                        s(project.suku),
    aldeia:                      s(project.aldeia),
    areatype:                    s(project.areatype),
    landtype:                    s(project.landtype),
    landlocation:                s(project.landlocation),
    cultural_evidence:           s(project.cultural_evidence),
    watersprings:                project.watersprings || false,
    commodities:                 s(project.commodities),
    yearstart:                   s(project.yearstart),
    yearclaiming:                s(project.yearclaiming),
    actors:                      s(project.actors),
    secondaryactors:             s(project.secondaryactors),
    legalstatusfarmerspov:       s(project.legalstatusfarmerspov),
    ownershipprooffarmerspov:    s(project.ownershipprooffarmerspov),
    juridicsituationclaming:     s(project.juridicsituationclaming),
    legalstatusotherpov:         s(project.legalstatusotherpov),
    ownershipproffotherpov:      s(project.ownershipproffotherpov),
    juridicsituationotherpov:    s(project.juridicsituationotherpov),
    conflicthistory:             s(project.conflicthistory),
    conflictarea:                s(project.conflictarea),
    impactedhouseholds:          s(project.impactedhouseholds),
    impactedfamilymembers:       s(project.impactedfamilymembers),
    impactedmen:                 s(project.impactedmen),
    impactedwomen:               s(project.impactedwomen),
    impactedyouth:               s(project.impactedyouth),
    impacteddisabled:            s(project.impacteddisabled),
    impactedelderly:             s(project.impactedelderly),
    futureplans:                 s(project.futureplans),
    plannedcompensation:         s(project.plannedcompensation),
    ksisupporttype:              s(project.ksisupporttype),
    ksisupportstart:             s(project.ksisupportstart),
    supportuseland:              s(project.supportuseland),
    additionalinformation:       s(project.additionalinformation),
    boundary_east:               s(project.boundary_east),
    boundary_west:               s(project.boundary_west),
    boundary_north:              s(project.boundary_north),
    boundary_south:              s(project.boundary_south),
    informant_name:              s(project.informant_name),
    informant_org:               s(project.informant_org),
    informant_position:          s(project.informant_position),
    informant_contact:           s(project.informant_contact),
    enumerator_name:             s(project.enumerator_name),
    enumerator_org:              s(project.enumerator_org),
    enumerator_position:         s(project.enumerator_position),
    enumerator_contact:          s(project.enumerator_contact),
    parte_interesada_tipo:       s(project.parte_interesada_tipo),
    parte_interesada_individu:   s(project.parte_interesada_individu),
  };

  return (
    <Grid>
      <Grid.Row>
        <Grid.Column width={16}>
          <Breadcrumb>
            <Breadcrumb.Section as={Link} to='/cases'>Cases</Breadcrumb.Section>
            <Breadcrumb.Divider />
            <Breadcrumb.Section active>Update</Breadcrumb.Section>
            <Breadcrumb.Divider />
            <Breadcrumb.Section as={Link} to={`/cases/${idProject}`}>
              {_.capitalize(project.name)}
            </Breadcrumb.Section>
          </Breadcrumb>
        </Grid.Column>
      </Grid.Row>

      <Grid.Row>
        <Grid.Column width={16}>
          {error && (
            <Message negative>
              <Message.Header>Error</Message.Header>
              <p>{error}</p>
            </Message>
          )}
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(true);
              setError(null);

              const payload = { ...values };
              ['areatype', 'landtype', 'actors', 'legalstatusfarmerspov',
               'legalstatusotherpov', 'secondaryactors', 'ksisupporttype', 'parte_interesada_tipo'].forEach(k => {
                if (Array.isArray(payload[k])) payload[k] = payload[k].join(',');
              });

              apiRequest(`/api/cases/${idProject}`, {
                method: 'PUT',
                body: JSON.stringify(payload),
              })
                .then(async (res) => {
                  const data = await res.json();
                  if (!res.ok) throw new Error(data.message || `HTTP ${res.status}`);
                  return data;
                })
                .then(() => history.push(`/cases/${idProject}`))
                .catch((err) => {
                  setError(err.message);
                  setSubmitting(false);
                });
            }}
          >
            {(formik) => (
              <Form onSubmit={formik.handleSubmit}>
                <ProjectInnerForm formik={formik} />
                <Segment basic>
                  <Button
                    primary
                    size='large'
                    content='Salva mudansa'
                    type='submit'
                    disabled={formik.isSubmitting || !formik.isValid}
                    loading={formik.isSubmitting}
                  />
                  <Button
                    content='Kansela'
                    onClick={() => history.push(`/cases/${idProject}`)}
                    type='button'
                  />
                </Segment>
              </Form>
            )}
          </Formik>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default ProjectsUpdate;
